import React, { useEffect, useMemo, useState } from "react"
import styles from "../styles/Game.module.scss"
import { useStopwatch } from "react-timer-hook"
// import Video from "./Video"
import { CSSTransition } from "react-transition-group"
import { Twirl as Hamburger } from "hamburger-react"
import Menu from "./Menu"
import HowToPlay from "./HowToPlay"

// need to use node verson 16.7.0 for firebase deploy to work, run terminal as admin and type nvm use 16.7.0

enum Storage {
  last = "last score",
  top = "top score",
}

const Game = () => {
  const [goal, setGoal] = useState(0)
  const [score, setScore] = useState(0)
  const [myCount, setMycount] = useState(0)
  const [showCurrent, setShowCurrent] = useState<boolean>(false)
  const [showFull, setShowFull] = useState(false)
  const [showHalf, setShowHalf] = useState(false)
  const [showMinus, setShowMinus] = useState(false)
  const [finish, setFinish] = useState(false)
  const [pointVal, setPointVal] = useState(0)
  const [ptArr, setPtArr] = useState<number[]>([])
  const [menuOpen, setMenuOpen] = useState(false)
  const [totalMin, setTotalMin] = useState(1)
  const [firstNum, setFirstNum] = useState(4)
  const [secondNum, setSecondNum] = useState(10)
  const [showHowTo, setShowHowTo] = useState(false)
  const [minGoal, setMinGoal] = useState<number>()
  const [currentArr, setCurrentArr] = useState([0])

  const { seconds, minutes, isRunning, start, pause, reset } = useStopwatch({
    autoStart: false,
  })

  useEffect(() => {
    if (minutes === 1) {
      setFirstNum(6)
      setSecondNum(13)
    }
    if (minutes === 2) {
      setFirstNum(8)
      setSecondNum(15)
    }
  }, [minutes])

  const onStart = () => {
    start()
    setShowCurrent(true)
    setTimeout(() => {
      setShowCurrent(false)
    }, 3000)
    makeGoal(current)
  }

  const current = useMemo(() => seconds, [seconds])

  // Auto restart? needs to be False
  const resetGame = () => {
    reset(undefined, false)
    setMycount(0)
    setGoal(0)
    setScore(0)
    show3Secs()
    setPtArr([0])
    setMinGoal(0)
    setFirstNum(4)
    setSecondNum(10)
  }

  // when hit 1/2/3 minutes, finish game
  useEffect(() => {
    if (minutes >= totalMin) {
      reset()
      pause()
      setFinish(true)
    }
  }, [minutes, pause, reset, totalMin])

  const makeGoal = (time: number) => {
    const rand = (min: number, max: number) => {
      return Math.floor(Math.random() * (max - min + 1) + min)
    }
    const randNum = rand(firstNum, secondNum)
    setGoal((time += randNum))
    setPointVal(randNum)

    setPtArr((prev) => [...prev, randNum])
  }

  // Checks total time set and sets goal for 59th second and sets points
  useEffect(() => {
    if (totalMin === 1) {
      if (goal >= 60) {
        setGoal(59)
        setPointVal(59 - currentArr[currentArr.length - 1])
        setPtArr((prev) => [...prev, 59 - currentArr[currentArr.length - 1]])
      }
    }
    if (totalMin === 2) {
      if (!minGoal && goal > 59) {
        setMinGoal(1)
        setGoal((prev) => prev - 60)
      }
      if (minGoal === 1 && goal > 59) {
        setGoal(59)
        setPointVal(59 - currentArr[currentArr.length - 1])
        setPtArr((prev) => [...prev, 59 - currentArr[currentArr.length - 1]])
      }
    }
    if (totalMin === 3) {
      if (!minGoal && goal > 59) {
        setMinGoal(1)
        setGoal((prev) => prev - 60)
      }
      if (minGoal === 1 && goal > 59) {
        setMinGoal(2)
        setGoal((prev) => prev - 60)
      }
      if (minGoal === 2 && goal > 59) {
        setGoal(59)
        setPointVal(59 - currentArr[currentArr.length - 1])
        setPtArr((prev) => [...prev, 59 - currentArr[currentArr.length - 1]])
      }
    }
  }, [currentArr, goal, minGoal, totalMin])

  // const MakeRand = (min: number, max: number) => {
  //   // min and max included
  //   return Math.floor(Math.random() * (max - min + 1) + min)
  // }

  const hidetime = () => {
    setShowCurrent(false)
  }

  const show3Secs = () => {
    setShowCurrent(true)
    setTimeout(() => {
      hidetime()
    }, 3000)
  }

  const makeGoalPreCheck = () => {
    if (goal === 59 && current < 59) return
    makeGoal(current)
  }

  const timeHandler = () => {
    if (current === 0 && minutes < 1) return
    if (!isRunning) return
    show3Secs()
    setMycount(current)
    makeGoalPreCheck()
    checkScore(current)
    setCurrentArr((prev) => [...prev, current])
  }

  useEffect(() => {
    // console.log("cur array", currentArr)
    console.log("point val", pointVal)
  }, [currentArr, pointVal])

  useEffect(() => {
    console.log("pt arr", ptArr)
  }, [ptArr])

  // checks if current time now is same as goal time and rewards the point value
  const checkScore = (cur: number) => {
    console.log("cur", cur, "goal", goal)
    if (goal === cur) {
      setScore((prev) => (prev += pointVal))
      setShowFull(true)
      setTimeout(() => {
        setShowFull(false)
      }, 2000)
    }
    if (goal === cur + 1 || goal === cur - 1) {
      const halfPnts = pointVal / 2
      setScore((prev) => (prev += halfPnts))
      setShowHalf(true)
      setTimeout(() => {
        setShowHalf(false)
      }, 2000)
    }
    if (goal > cur + 1 || goal < cur - 1) {
      setScore((prev) => (prev -= 5))
      setShowMinus(true)
      setTimeout(() => {
        setShowMinus(false)
      }, 2000)
    }
  }

  const removeTopScore = () => {
    localStorage.removeItem(Storage.top)
  }

  // TODO add to end game modal "Perfect Score!"
  const gameOverHandler = () => {
    const top = localStorage.getItem(Storage.top)
    if (top && score > Number(top)) {
      return `Times Up! You Set a New Record! ${score}`
    }
    if (top && score === Number(top)) {
      return `Times Up! You Tied Your Record!`
    } else {
      return `Times Up! Your Score: ${score}`
    }
  }

  const lastScore = localStorage.getItem(Storage.last)
  const topScore = useMemo(() => {
    return localStorage.getItem(Storage.top)
  }, [menuOpen])

  const closeModal = () => {
    setFinish(false)
    if (!topScore) {
      localStorage.setItem(Storage.top, `${score}`)
    }
    if (score > Number(topScore)) {
      localStorage.setItem(Storage.top, `${score}`)
    }
    localStorage.setItem(Storage.last, `${score}`)
    setScore(0)
    setMycount(0)
    setGoal(0)
    reset()
    pause()
    setMinGoal(0)
    setFirstNum(4)
    setSecondNum(10)
  }

  const formatMin = () => {
    if (minutes < 10) {
      return `0${minutes}`
    } else {
      return minutes
    }
  }

  const formatSec = () => {
    if (seconds < 10) {
      return `0${seconds}`
    } else {
      return seconds
    }
  }

  // this checks the points array that is the random numbers and last point value and shows amount of points that were given in the point value
  const ptsGiven = ptArr[ptArr.length - 2]

  const closeMenu = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    setMenuOpen(false)
    setShowHowTo(false)
  }

  const openMenu = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    setMenuOpen((prev) => !prev)
  }

  const toggleHowTo = () => {
    setShowHowTo((prev) => !prev)
  }

  return (
    <div className={styles.main}>
      <div onClick={(e) => openMenu(e)} className={styles.hamburger}>
        <Hamburger
          color="white"
          toggled={menuOpen}
          // toggle={setMenuOpen}
          size={40}
        />
      </div>

      <CSSTransition
        in={menuOpen}
        unmountOnExit
        timeout={800}
        classNames="animenu"
      >
        <Menu
          setTotalMin={setTotalMin}
          lastScore={lastScore}
          topScore={topScore}
          totalMin={totalMin}
          removeTop={removeTopScore}
          toggleHowTo={toggleHowTo}
        />
      </CSSTransition>

      {/* <div className={styles.bgVid}>
        <Video
          url="https://www.youtube.com/watch?v=nSJ67PGjQfQ&t=83s"
          width={1920}
          height={1080}
        />
      </div> */}

      {finish && (
        <div className={styles.modal}>
          <div className={styles.final}>{gameOverHandler()}</div>
          <div>
            <button className={styles.modalBtn} onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      )}
      <h3 className={styles.running}>
        {isRunning ? "Time is Running" : "Paused"}
      </h3>
      <div className={styles.buttonContainer}>
        <button className={styles.button} onClick={onStart}>
          Start
        </button>
        <button className={styles.button} onClick={pause}>
          Pause
        </button>

        <button className={styles.button} onClick={resetGame}>
          Reset
        </button>
      </div>
      <div className={styles.score}>
        <div>Score: {score}</div>
        <CSSTransition
          in={showFull}
          unmountOnExit
          timeout={1000}
          classNames="animate"
        >
          <div>+ {ptsGiven}</div>
        </CSSTransition>
        <CSSTransition
          in={showHalf}
          unmountOnExit
          timeout={1000}
          classNames="animate"
        >
          <div>+ {ptsGiven / 2}</div>
        </CSSTransition>
        {/* {showHalf && `+ ${ptsGiven / 2}`} */}
        <CSSTransition
          in={showMinus}
          unmountOnExit
          timeout={1000}
          classNames="animate"
        >
          <div className={styles.minus}>-5</div>
        </CSSTransition>
        {/* {showMinus && <div className={styles.minus}>-5</div>} */}
      </div>
      <div className={styles.now}>
        {" "}
        <button className={styles.button} onClick={timeHandler}>
          Now
        </button>
      </div>
      <div className={styles.time}>Your Count: {myCount}</div>
      <div className={styles.timeGoal}>
        Goal: {minGoal && minGoal >= 1 ? `0${minGoal}` : "00"}:
        {goal < 10 ? `0${goal}` : goal}
      </div>
      {showCurrent && (
        <div className={styles.timeGoal}>
          {formatMin()}:{formatSec()}
        </div>
      )}
      <div onClick={(e) => closeMenu(e)} className={styles.bg} />
      {/* {showHowTo && <HowToPlay toggleHowTo={toggleHowTo} />} */}
      <CSSTransition
        in={showHowTo}
        unmountOnExit
        timeout={800}
        classNames="animate"
      >
        <HowToPlay toggleHowTo={toggleHowTo} />
      </CSSTransition>
    </div>
  )
}

export default Game
